import { isEmpty } from 'lodash';
import Mousetrap from 'mousetrap';

type Key = string | string[];

type Callback = (e: KeyboardEvent, key: string) => boolean | void;

(function () {
  const _globalCallbacks = {};
  const _originalStopCallback = Mousetrap.prototype.stopCallback;

  Mousetrap.prototype.stopCallback = function (e, element, combo, sequence) {
    const self = this;

    if (self.paused) {
      return true;
    }

    if (_globalCallbacks[combo] || _globalCallbacks[sequence]) {
      return false;
    }

    return _originalStopCallback.call(self, e, element, combo);
  };

  Mousetrap.prototype.bindGlobal = function (keys, callback, action) {
    const self = this;
    self.bind(keys, callback, action);

    if (keys instanceof Array) {
      keys.forEach((key) => {
        _globalCallbacks[key] = true;
      });
      return;
    }

    _globalCallbacks[keys] = true;
  };

  Mousetrap.prototype.unbindGlobal = function (keys, action) {
    this.unbind(keys, action);

    if (keys instanceof Array) {
      keys.forEach((key) => {
        _globalCallbacks[key] = false;
      });
      return;
    }

    _globalCallbacks[keys] = false;
  };

  Mousetrap.init();
})();

const createShortcutService = () => ({
  bind: ({ key, callback, node }: { key: Key; callback: Callback; node?: HTMLElement }) => {
    return isEmpty(node) ? Mousetrap.bind(key, callback) : Mousetrap(node).bind(key, callback);
  },
  globalBind: ({ key, callback }: { key: Key; callback: Callback }) => {
    Mousetrap.bindGlobal(key, callback);
  },
  globalUnbind: ({ key }: { key: Key }) => {
    Mousetrap.unbindGlobal(key);
  },
  unbind: (mousetrap, { key }: { key: Key }) => {
    mousetrap.unbind(key);
  },
});

const shortcutService = createShortcutService();

export default shortcutService;
